import React from 'react'
// import NoteContext from '../context/notes/notecontext';
const About = () => {
  return (
    <div>
      this is about
    </div>
  )
}

export default About
